import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ApproveIcon } from '../../assets/icons/clipboard-check.svg';
import { ReactComponent as AssignedIcon } from '../../assets/icons/inbox.svg';
import { ReactComponent as DraftsIcon } from '../../assets/icons/file-pencil.svg';
import { ReactComponent as SubmittedIcon } from '../../assets/icons/file-checkmark.svg';
import { ReactComponent as LogIcon } from '../../assets/icons/parchment.svg';

import Colors from '../../constants/Colors';
import Permissions from '../../auth/Permissions';

const SUMMARY_CARDS = [
  {
    key: 'approve',
    label: 'Approve',
    icon: ApproveIcon,
    iconBg: Colors.ORANGE_100,
    textColor: Colors.ORANGE_500,
    highlight: true,
    linkText: 'Review approvals →',
    path: '/forms/approve',
  },
  {
    key: 'assigned',
    label: 'Assigned',
    icon: AssignedIcon,
    iconBg: '#0666EE1A',
    textColor: Colors.GRAY_950,
    linkText: 'Open assigned →',
    path: '/forms/assigned',
  },
  {
    key: 'drafts',
    label: 'Drafts',
    icon: DraftsIcon,
    iconBg: '#7E4ED71A',
    textColor: Colors.GRAY_950,
    linkText: 'Continue drafts →',
    path: '/forms/drafts',
  },
  {
    key: 'submitted',
    label: 'Submitted',
    icon: SubmittedIcon,
    iconBg: Colors.GREEN_100,
    textColor: Colors.GRAY_950,
    linkText: 'View submitted →',
    path: '/forms/submitted',
  },
  {
    key: 'log',
    label: 'Log',
    icon: LogIcon,
    iconBg: Colors.GRAY_100,
    textColor: Colors.GRAY_950,
    linkText: 'Open log →',
    path: '/forms/log',
    permissions: 'FORMS_READ_LOGS',
  },
];

export default function FormsSummaryCards({
  counts,
  trends,
  onNavigate,
}) {
  return (
    <div className="forms-summary-cards">
      {SUMMARY_CARDS
        .filter(({ permissions }) => !permissions || Permissions.has(permissions))
        .map(({
          key,
          label,
          icon: Icon,
          iconBg,
          textColor,
          highlight,
          linkText,
          path,
        }) => (
          <button
            key={key}
            type="button"
            className={`forms-summary-card${highlight && counts.approve > 0 ? ' forms-summary-card--highlight' : ''}`}
            onClick={() => onNavigate(path)}
          >
            <div className="forms-summary-card-header">
              <span
                className="forms-summary-card-icon"
                style={{ backgroundColor: iconBg }}
              >
                <Icon />
              </span>
              <span className="forms-summary-card-label">{label}</span>
            </div>
            <div className="forms-summary-card-value-container">
              <div className="forms-summary-card-value" style={{ color: textColor}}>
                {(counts[key] ?? 0).toLocaleString()}
              </div>
              {trends[key] && (
                <div className="forms-summary-card-trend">{trends[key]}</div>
              )}
            </div>
            <span className="forms-summary-card-link">{linkText}</span>
          </button>
        ))}
    </div>
  );
}

FormsSummaryCards.propTypes = {
  counts: PropTypes.shape({
    approve: PropTypes.number,
    assigned: PropTypes.number,
    drafts: PropTypes.number,
    submitted: PropTypes.number,
    log: PropTypes.number,
  }).isRequired,
  trends: PropTypes.shape({
    approve: PropTypes.string,
    assigned: PropTypes.string,
    drafts: PropTypes.string,
    submitted: PropTypes.string,
    log: PropTypes.string,
  }),
  onNavigate: PropTypes.func.isRequired,
};

FormsSummaryCards.defaultProps = {
  trends: {},
};
